<script>
/**
 * ****************************************************************************
 * @description     :   Component for popup search personcharge
 * @created at      :   2022/05/20
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import repository from '@/utils/repository';

/**
 * Define component chat for popup search person harge
 */

var ra001700v = {
    template: template,
    props: {
        onSelected: Function,
        initData: Object
    },
    data() {
        return {
            search: '',
            resultSearch: []
        };
    },
    methods: {
        doSearch: function () {
            repository
                .get(`inquiry/ra001700v`, {
                    params: {
                        search: this.search,
                        kinds: this.initData?.kinds ?? 1
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.resultSearch = data.Data;
                    } else {
                        this.resultSearch = [];
                    }
                });
        },
        selectFirstRow() {
            if (
                this.resultSearch &&
                this.resultSearch.length > 0 &&
                this.onSelected
            ) {
                this.onSelected(this.resultSearch[0]);
            }
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
        }
    }
};
export default ra001700v;
</script>
